import toast from 'react-hot-toast'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import * as yup from 'yup'
import { UnitLoc } from 'src/api/models'
import { useForm } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { Notification } from 'src/components/Notification'
import { skuit } from 'src/services/skuit'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface LostProps {
  count: number
}

const lostSchema = yup.object().shape({
  count: yup.number().required().default(1).label('Number to Report Lostd'),
})

interface Props {
  open: boolean
  handleClose: () => void
  unit?: UnitLoc
  onSave?: () => void
}

export const ReportLostDialog = (props: Props) => {
  const { open, handleClose, unit, onSave } = props
  const classes = useStyles()
  const { Form, Field, data: formData } = useForm(lostSchema)

  const onSubmit = (data: LostProps) => {
    if (!unit) {
      toast.error(() => <Notification message="Need to specify what unit to mark as lost" />)
      return
    }
    skuit.sc.units
      .lost(unit.location?.guid || '', unit.product?.guid || '', {...data, "batch": unit?.batch?.guid})
      .then(() => {
        handleClose()
        toast.success(() => <Notification message={`Marked ${formData.values.count} as lost!`} />)
      })
      .catch((error) => {
        if (error?.response?.data?.details) {
          toast.error(() => <Notification message={`Failed to mark as lost.`} />)
        } else {
          toast.error(() => <Notification message={`Failed to mark as as lost: ${error}`} />)
        }
        setApiErrors(formData.setError, error)
      })
    onSave?.()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>Report Losts</DialogTitle>
        <DialogContent>
          <Field
            name="count"
            defaultValue={1}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                type="number"
                variant="standard"
                label="Number to Report Lost"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value || undefined)
                }
                value={value}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
